import fetch from '@/utils/fetch'
import { helpListURI } from './urls'
interface IHelpListParam {
  pageNo: number
  pageSize: number
  questiontype: number
}
export function getHelpList(params: IHelpListParam): Promise<any> {
  return fetch.get(helpListURI, { params })
}
